import React, {useEffect} from "react";
import {Box, Button, Typography} from "@material-ui/core";
import {inject, observer} from "mobx-react";
import {injectIntl} from "react-intl";
import {useStyles} from "./styles/NoticeStyle";
import NoticeBanner from "./NoticeBanner";
import NoticeContent from "./NoticeContent";
import {URL_TYPE} from "../../../routes/Routes";
import {useHistory} from "react-router-dom";
import {ReactComponent as ArrowLeftIcon} from "../../../common/images/ArrowLeftIcon.svg";
import {USER_TYPE} from "../../../stores/UserStore";
import {NotificationType, TabType} from "../../../stores/NoticeStore";

function NoticeDetail(props) {
    const classes = useStyles();
    const {noticeStore, localeStore, groupStore} = props;
    const {intl} = props;
    const history = useHistory();
    const noticeId = props.match.params.noticeId;
    const userType = props.authStore.getUserType();


    useEffect(() => {
        groupStore.initLocaleGroup();
        noticeStore.setCurrentTab(TabType.title)
        noticeStore.setCurrentPage(false);
        if (noticeId > 0) {
            noticeStore.getNoticeContents(noticeId, localeStore.locale.toUpperCase(), (localeCode) => {
                groupStore.getLocalGroups(localeCode);
            })
        } else {
            noticeStore.initNoticeDetailInfo();
        }
        if (userType === USER_TYPE.LocaleAdmin) {
            noticeStore.setSelectOption(NotificationType.Locale);
            noticeStore.setSelectLocale(props.authStore.loginUser.localeCode);
            groupStore.getLocalGroups(props.authStore.loginUser.localeCode);
            noticeStore.setSelectGroupId(NotificationType.All);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [localeStore.locale]);

    const gobackToNoticeList = () => {
        history.push(URL_TYPE.Notice);
    }

    const handlePage = () => {
        noticeStore.setCurrentPage(noticeStore.currentPage);
        noticeStore.setCurrentTab(TabType.title)
        window.scrollTo(0, 0);
    }

    const handleRegister = async () => {
        if (noticeStore.selectOption === NotificationType.Locale && noticeStore.selectLocale === "") {
            alert(`${intl.formatMessage({id: "SelectAlert"})}`);
        } else {
            if (!!noticeStore.notificationImage?.image) {
                if (noticeId > 0) {
                    if (noticeStore.selectOption === NotificationType.All) {
                        await noticeStore.updateAllNotice();
                    } else {
                        await noticeStore.updateLocaleNotice();
                    }
                } else {
                    if (noticeStore.selectOption === NotificationType.All) {
                        await noticeStore.createAllNotice();
                    } else {
                        await noticeStore.createLocaleNotice();
                    }
                }
                history.push(`/notice`);
            } else {
                alert(`${intl.formatMessage({id: "SelectImage"})}`)
            }
        }
    }

    const disable1 = !(noticeStore.title && noticeStore.subtitle);
    const disable2 = !noticeStore.content;

    return (
        <Box className={classes.root}>
            {noticeStore.currentPage ? (<NoticeBanner noticeId={noticeId}/>) : (<NoticeContent/>)}
            <Box className={classes.saveButtonArea}>
                <Box>
                    <Button variant={'text'} onClick={gobackToNoticeList}>
                        <ArrowLeftIcon/>
                        <Typography>{intl.formatMessage({id: "List"})}</Typography>
                    </Button>
                </Box>
                <Box>
                    {noticeStore.currentPage ? (
                        <Button disabled={disable1}
                                style={{color: 'white', backgroundColor: disable1 ? 'gray' : '#7445FF'}}
                                variant={'contained'} onClick={handlePage}>
                            <Typography>{intl.formatMessage({id: "next"})}</Typography>
                        </Button>
                    ) : (
                        <Box display={"flex"} flexdirection={"row"}>
                            <Box marginRight={1}>
                                <Button style={{color: 'white', backgroundColor: '#7445FF'}}
                                        variant={'contained'} onClick={handlePage}>
                                    <Typography>{intl.formatMessage({id: "previous"})}</Typography>
                                </Button>
                            </Box>
                            <Box>
                                <Button disabled={disable2}
                                        style={{color: 'white', backgroundColor: disable2 ? 'gray' : '#7445FF'}}
                                        variant={'contained'} onClick={handleRegister}>
                                    <Typography>{noticeStore.id === 0 ? intl.formatMessage({ id: "register" }) : intl.formatMessage({ id: "modify" })}</Typography>
                                </Button>
                            </Box>
                        </Box>
                    )}
                </Box>
            </Box>
        </Box>
    )
}

export default inject('authStore', 'noticeStore', 'localeStore', 'groupStore')(injectIntl(observer(NoticeDetail)));